import groupBy from 'lodash/groupBy';
import sortBy from 'lodash/sortBy';
import { Medialink } from '../../../../api/medialink';
import Role from '../../../../core/security/role';

export function groupByContentType(medialinks: Medialink[]) {
  const medialinksSortedByContentType = sortByContentType(medialinks);

  return groupBy(medialinksSortedByContentType, ({ contentType }) => contentType.category || contentType.name);
}

export function sortByContentType(medialinks: Medialink[]) {
  return sortBy(medialinks, 'contentType.category', 'contentType.name');
}

export function getRoleTranslationKey(role: Role, author = false) {
  switch (role) {
    case Role.STUDENT:
      return author ? 'ROLES.AUTHOR' : 'ROLES.STUDENT';
    case Role.TEACHER:
      return author ? 'ROLES.AUTHOR' : 'ROLES.TEACHER';
    case Role.EXTERNAL:
      return author ? 'ROLES.AUTHOR' : 'ROLES.EXTERNAL';
    case Role.SALES:
      return author ? 'ROLES.AUTHOR' : 'ROLES.SALES';
    case Role.SUPPORT:
      return author ? 'ROLES.AUTHOR' : 'ROLES.SUPPORT';
    case Role.PUBLISHER:
      return 'ROLES.PUBLISHER';
    case Role.EDITOR:
      return 'ROLES.EDITOR';
    case Role.PRODUCTION:
      return 'ROLES.PRODUCTION';
    case Role.SYSADMIN:
      return 'ROLES.SYSADMIN';
    default:
      return role;
  }
}
